import React from 'react';
import * as _ from 'lodash';
import { getRunProgressPercent } from '../simulation.model';

/* How far a run has got: the bar is the events processed or failed out of the events planned. */
export const RunProgress = ({ progress, status, detailed }) => {
    const percent = getRunProgressPercent(progress);
    const planned = _.get(progress, 'eventsPlanned', 0);
    const done =
        _.get(progress, 'eventsProcessed', 0) +
        _.get(progress, 'eventsFailed', 0);
    const failed = _.get(progress, 'eventsFailed', 0);

    return (
        <div className={'sim-progress'}>
            <div className={'sim-progress-bar ' + _.toLower(status)}>
                <div
                    className={'sim-progress-fill'}
                    style={{ width: percent + '%' }}
                />
            </div>
            <div className={'sim-progress-text'}>
                {planned
                    ? `${done} of ${planned} events (${percent}%)`
                    : 'No events planned yet'}
                {failed > 0 && ` · ${failed} failed`}
                {detailed &&
                    planned > 0 &&
                    ` · ${_.get(progress, 'eventsGenerated', 0)} generated`}
            </div>
        </div>
    );
};
